export default {
  on: {
    pageInit: function () {
      var app = this.$app;
      var FUND_URL = window.baseURL + 'fund.php';
      var token = localStorage.getItem('authToken');
      function fwReq(data, before, ok, fail) {
        app.methods.request(FUND_URL, data, 'json', before || function () {
        }, ok || function () {
        }, fail || function () {
        });
      }
      function fmtUSD(n) {
        var v = Number(n);
        if (n == null || n === '' || isNaN(v))
          v = 0;
        return '$' + v.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      }
      function esc(s) {
        return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
      }
      function toast(msg) {
        app.toast.show({
          text: msg,
          closeTimeout: 3000
        });
      }
      function ok(res) {
        return res && (res.status === 'success' || res.status === 'Success' || res.code == 200);
      }
      function copyText(text) {
        if (!text)
          return;
        if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).then(function () {
            app.toast.show({
              text: 'Copied!',
              closeTimeout: 1500
            });
          });
        } else {
          var tmp = document.createElement('input');
          tmp.value = text;
          document.body.appendChild(tmp);
          tmp.select();
          document.execCommand('copy');
          document.body.removeChild(tmp);
          app.toast.show({
            text: 'Copied!',
            closeTimeout: 1500
          });
        }
      }
      var fwMinTransfer = 10, fwMaxTransfer = 50000, fwBalance = 0;
      var fwMembers = [];
      var fwSelectedId = '';
      var fwHistPage = 0, fwHistPages = 1, fwHistLoading = false, fwHistEverLoaded = false;
      var pageEl = this.$el && this.$el[0] || this.$el || document;
      var $ = function (sel) {
        return pageEl.querySelector(sel);
      };
      var byId = function (id) {
        return pageEl.querySelector('#' + id);
      };
      function loadBalance(showProgress) {
        fwReq({
          token: token,
          fundBalance: 1
        }, function () {
          if (showProgress)
            app.dialog.progress('Loading\u2026');
        }, function (res) {
          if (showProgress)
            app.dialog.close();
          if (!ok(res)) {
            toast(res && res.msg || 'Could not load balance.');
            return;
          }
          fwBalance = Number(res.balance) || 0;
          $('.fw-balance').textContent = fmtUSD(res.balance);
          var mini = $('.fw-balance-mini');
          if (mini)
            mini.textContent = fmtUSD(res.balance);
          $('.fw-received').textContent = fmtUSD(res.totalReceived);
          $('.fw-distributed').textContent = fmtUSD(res.totalSent);
          $('.fw-invested').textContent = fmtUSD(res.totalInvested);
          if (res.minTransfer != null && res.minTransfer !== '') {
            fwMinTransfer = Number(res.minTransfer);
            byId('fw-dist-amount').min = fwMinTransfer;
          }
          if (res.maxTransfer != null && res.maxTransfer !== '') {
            fwMaxTransfer = Number(res.maxTransfer);
            byId('fw-dist-amount').max = fwMaxTransfer;
          }
          byId('fw-amount-hint').textContent = 'Min ' + fmtUSD(fwMinTransfer) + ' \xB7 Max ' + fmtUSD(fwMaxTransfer);
        }, function () {
          if (showProgress)
            app.dialog.close();
          toast('Connection error, please try again.');
        });
      }
      function loadMembers() {
        fwReq({
          token: token,
          fundNetworkMembers: 1
        }, null, function (res) {
          var el = byId('fw-members');
          if (ok(res)) {
            fwMembers = res.members || [];
            if (!fwMembers.length) {
              el.innerHTML = '<div class="fw__empty-msg">You have no network members to distribute funds to.</div>';
            } else {
              renderMembers('');
            }
          } else {
            el.innerHTML = '<div class="fw__empty-msg">' + esc(res && res.msg || 'Could not load members.') + '</div>';
          }
        }, function () {
          byId('fw-members').innerHTML = '<div class="fw__empty-msg">Connection error \u2014 tap Refresh to retry.</div>';
        });
      }
      function renderMembers(query) {
        var el = byId('fw-members');
        var q = (query || '').toLowerCase().trim().replace(/^@+/, '');
        var list = !q ? fwMembers : fwMembers.filter(function (m) {
          return String(m.name || '').toLowerCase().indexOf(q) !== -1 || String(m.username || '').toLowerCase().indexOf(q) !== -1;
        });
        var countEl = byId('fw-member-count');
        if (countEl)
          countEl.textContent = fwMembers.length ? q ? list.length + '/' + fwMembers.length : fwMembers.length : '';
        if (!list.length) {
          el.innerHTML = '<div class="fw__empty-msg">No members match "' + esc(query) + '".</div>';
          return;
        }
        var html = '';
        list.forEach(function (m) {
          var nm = String(m.name || m.username || '?');
          var initial = nm.charAt(0).toUpperCase();
          html += '<button type="button" class="fw__member-item" data-id="' + esc(m.id) + '" data-name="' + esc(nm) + '" data-uname="' + esc(m.username || '') + '" data-initial="' + esc(initial) + '">' + '<span class="fw__member-av">' + esc(initial) + '</span>' + '<span class="fw__member-info">' + '<span class="fw__member-name">' + esc(nm) + '</span>' + '<span class="fw__member-uname">@' + esc(m.username || '') + '</span>' + '</span>' + '<svg class="fw__member-chev" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><polyline points="9 18 15 12 9 6"/></svg>' + '</button>';
        });
        el.innerHTML = html;
      }
      byId('fw-members').addEventListener('click', function (e) {
        var btn = e.target.closest('.fw__member-item');
        if (!btn)
          return;
        fwSelectedId = btn.getAttribute('data-id');
        byId('fw-recipient-id').value = fwSelectedId;
        byId('fw-recipient-name').textContent = btn.getAttribute('data-name');
        byId('fw-recipient-uname').textContent = '@' + (btn.getAttribute('data-uname') || '');
        byId('fw-recipient-avatar').textContent = btn.getAttribute('data-initial') || '?';
        byId('fw-recipient-badge').style.display = 'flex';
        byId('fw-search-wrap').style.display = 'none';
      });
      byId('fw-recipient-clear').addEventListener('click', function () {
        fwSelectedId = '';
        byId('fw-recipient-id').value = '';
        byId('fw-recipient-badge').style.display = 'none';
        byId('fw-search-wrap').style.display = '';
        byId('fw-search').value = '';
        byId('fw-search-clear').style.display = 'none';
        renderMembers('');
      });
      function doSearch() {
        var inp = byId('fw-search');
        if (!inp)
          return;
        byId('fw-search-clear').style.display = inp.value ? 'flex' : 'none';
        renderMembers(inp.value);
      }
      [
        'input',
        'keyup',
        'change',
        'search'
      ].forEach(function (ev) {
        pageEl.addEventListener(ev, function (e) {
          if (e.target && e.target.id === 'fw-search')
            doSearch();
        });
      });
      byId('fw-search-clear').addEventListener('click', function () {
        var inp = byId('fw-search');
        inp.value = '';
        this.style.display = 'none';
        renderMembers('');
        inp.focus();
      });
      pageEl.addEventListener('click', function (e) {
        var chip = e.target.closest && e.target.closest('.fw__chip');
        if (!chip)
          return;
        var fill = chip.getAttribute('data-fill');
        var val;
        if (fill === 'min')
          val = fwMinTransfer;
        else if (fill === 'max')
          val = Math.min(fwBalance || fwMaxTransfer, fwMaxTransfer);
        else
          val = Number(fill);
        if (!val || val < fwMinTransfer)
          val = fwMinTransfer;
        byId('fw-dist-amount').value = Math.round(val * 100) / 100;
      });
      byId('fw-dist-submit').addEventListener('click', function () {
        if (!fwSelectedId) {
          toast('Please select a recipient.');
          return;
        }
        var amount = parseFloat(byId('fw-dist-amount').value);
        if (isNaN(amount) || amount < fwMinTransfer || amount > fwMaxTransfer) {
          toast('Amount must be between ' + fmtUSD(fwMinTransfer) + ' and ' + fmtUSD(fwMaxTransfer) + '.');
          return;
        }
        if (amount > fwBalance) {
          toast('Amount exceeds your available balance (' + fmtUSD(fwBalance) + ').');
          return;
        }
        fwReq({
          token: token,
          distributeFund: 1,
          toUserId: fwSelectedId,
          amount: amount.toFixed(2)
        }, function () {
          app.dialog.progress('Distributing\u2026');
        }, function (res) {
          app.dialog.close();
          if (!ok(res)) {
            toast(res && res.msg || 'Could not distribute funds.');
            return;
          }
          toast(res.msg || 'Funds distributed successfully.');
          if (res.newBalance != null) {
            fwBalance = Number(res.newBalance) || 0;
            $('.fw-balance').textContent = fmtUSD(res.newBalance);
            var mini = $('.fw-balance-mini');
            if (mini)
              mini.textContent = fmtUSD(res.newBalance);
          }
          fwSelectedId = '';
          byId('fw-recipient-id').value = '';
          byId('fw-dist-amount').value = '';
          byId('fw-recipient-badge').style.display = 'none';
          byId('fw-search-wrap').style.display = '';
          byId('fw-search').value = '';
          renderMembers('');
          loadBalance(false);
          if (fwHistEverLoaded)
            loadHistPage(true);
        }, function () {
          app.dialog.close();
          toast('Connection error, please try again.');
        });
      });
      var TYPE_META = {
        admin_credit: {
          sign: '+',
          cls: 'green',
          icon: 'in'
        },
        distribute_in: {
          sign: '+',
          cls: 'green',
          icon: 'in'
        },
        distribute_out: {
          sign: '\u2212',
          cls: 'red',
          icon: 'out'
        },
        invest_debit: {
          sign: '\u2212',
          cls: 'red',
          icon: 'inv'
        }
      };
      var ICON_SVG = {
        in: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><line x1="12" y1="5" x2="12" y2="19"/><polyline points="19 12 12 19 5 12"/></svg>',
        out: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><line x1="12" y1="19" x2="12" y2="5"/><polyline points="5 12 12 5 19 12"/></svg>',
        inv: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>'
      };
      function dayLabel(dateStr) {
        if (!dateStr)
          return '';
        var p = String(dateStr).slice(0, 10).split('-');
        if (p.length !== 3)
          return String(dateStr).slice(0, 10);
        var dt = new Date(+p[0], +p[1] - 1, +p[2]);
        if (isNaN(dt.getTime()))
          return p.join('-');
        var today = new Date();
        today.setHours(0, 0, 0, 0);
        var diff = Math.round((today - dt) / 86400000);
        if (diff === 0)
          return 'Today';
        if (diff === 1)
          return 'Yesterday';
        return dt.toLocaleDateString('en-US', {
          day: 'numeric',
          month: 'short',
          year: 'numeric'
        });
      }
      function timeLabel(dateStr) {
        var m = String(dateStr || '').match(/(\d{1,2}):(\d{2})/);
        if (!m)
          return '';
        var h = parseInt(m[1], 10);
        return (h % 12 || 12) + ':' + m[2] + ' ' + (h >= 12 ? 'PM' : 'AM');
      }
      var fwHistLastDay = '';
      function renderHistItem(it) {
        var meta = TYPE_META[it.type] || {
          sign: '',
          cls: 'neutral',
          icon: 'in'
        };
        var time = timeLabel(it.date);
        var bal = it.updatedBalance != null ? '<span class="fw__tx-bal">Balance ' + fmtUSD(it.updatedBalance) + '</span>' : '';
        var note = it.note ? '<div class="fw__tx-note">' + esc(it.note) + '</div>' : '';
        var ref = it.txnRef ? '<div class="fw__tx-ref"><span class="fw__tx-ref-tag">REF</span>' + '<span class="fw__tx-ref-id">' + esc(it.txnRef) + '</span></div>' : '';
        return '<div class="fw__tx">' + '<span class="fw__tx-ico fw__tx-ico--' + meta.cls + '">' + ICON_SVG[meta.icon] + '</span>' + '<div class="fw__tx-main">' + '<div class="fw__tx-row">' + '<span class="fw__tx-title">' + esc(it.label || it.type) + '</span>' + '<span class="fw__tx-amt fw__tx-amt--' + meta.cls + '">' + meta.sign + fmtUSD(it.amount) + '</span>' + '</div>' + '<div class="fw__tx-row fw__tx-row--sub">' + '<span class="fw__tx-time">' + esc(time) + '</span>' + bal + '</div>' + (note || ref ? '<div class="fw__tx-foot">' + note + ref + '</div>' : '') + '</div>' + '</div>';
      }
      function renderHistGroup(items) {
        var html = '';
        items.forEach(function (it) {
          var g = dayLabel(it.date);
          if (g && g !== fwHistLastDay) {
            html += '<div class="fw__tx-day">' + esc(g) + '</div>';
            fwHistLastDay = g;
          }
          html += renderHistItem(it);
        });
        return html;
      }
      var SPINNER = '<div class="fw__spinner"><span class="fw__spin-ring"></span> Loading\u2026</div>';
      var EMPTY_ICONS = {
        history: '<svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><line x1="10" y1="9" x2="8" y2="9"/></svg>',
        error: '<svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M1 1l22 22"/><path d="M16.72 11.06A10.94 10.94 0 0 1 19 12.55"/><path d="M5 12.55a10.94 10.94 0 0 1 5.17-2.39"/><path d="M10.71 5.05A16 16 0 0 1 22.58 9"/><path d="M1.42 9a15.91 15.91 0 0 1 4.7-2.88"/><path d="M8.53 16.11a6 6 0 0 1 6.95 0"/><line x1="12" y1="20" x2="12.01" y2="20"/></svg>'
      };
      function emptyState(kind, title, sub) {
        return '<div class="fw__empty">' + '<div class="fw__empty-ico fw__empty-ico--' + (kind === 'error' ? 'err' : 'gold') + '">' + (EMPTY_ICONS[kind] || EMPTY_ICONS.history) + '</div>' + '<div class="fw__empty-title">' + esc(title) + '</div>' + (sub ? '<div class="fw__empty-sub">' + esc(sub) + '</div>' : '') + '</div>';
      }
      function loadHistPage(reset) {
        if (fwHistLoading)
          return;
        if (!reset && fwHistPage >= fwHistPages)
          return;
        fwHistLoading = true;
        var page = reset ? 1 : fwHistPage + 1;
        var listEl = byId('fw-hist-list');
        var moreEl = byId('fw-hist-more');
        if (reset) {
          listEl.innerHTML = SPINNER;
          moreEl.style.display = 'none';
          fwHistLastDay = '';
        }
        fwReq({
          token: token,
          fundHistory: 1,
          page: page
        }, null, function (res) {
          fwHistLoading = false;
          fwHistEverLoaded = true;
          if (!ok(res)) {
            if (reset)
              listEl.innerHTML = emptyState('error', 'Could not load history', res && res.msg || 'Please try again in a moment.');
            else
              toast(res && res.msg || 'Could not load history.');
            return;
          }
          fwHistPage = Number(res.page) || page;
          fwHistPages = Number(res.pages) || 1;
          var items = res.items || [];
          if (reset)
            listEl.innerHTML = '';
          if (!items.length && reset) {
            listEl.innerHTML = emptyState('history', 'No transactions yet', 'Funds you receive, distribute, or invest will appear here.');
          } else {
            listEl.insertAdjacentHTML('beforeend', renderHistGroup(items));
          }
          moreEl.style.display = fwHistPage < fwHistPages ? '' : 'none';
        }, function () {
          fwHistLoading = false;
          if (reset)
            listEl.innerHTML = emptyState('error', 'Connection error', 'Check your internet and tap Refresh to retry.');
          else
            toast('Connection error, please try again.');
        });
      }
      byId('fw-hist-more').addEventListener('click', function () {
        loadHistPage(false);
      });
      byId('fw-panel-history').addEventListener('click', function (e) {
        var btn = e.target.closest('.fw-copy-btn');
        if (btn)
          copyText(btn.getAttribute('data-copy'));
      });
      var tabs = pageEl.querySelectorAll('.fw__tab');
      tabs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          tabs.forEach(function (b) {
            b.classList.remove('fw__tab--on');
          });
          this.classList.add('fw__tab--on');
          var tab = this.getAttribute('data-tab');
          byId('fw-panel-distribute').style.display = tab === 'distribute' ? '' : 'none';
          byId('fw-panel-history').style.display = tab === 'history' ? '' : 'none';
          if (tab === 'history' && !fwHistEverLoaded)
            loadHistPage(true);
        });
      });
      byId('fw-refresh').addEventListener('click', function (e) {
        e.preventDefault();
        loadBalance(true);
        var active = pageEl.querySelector('.fw__tab--on');
        if (active && active.getAttribute('data-tab') === 'history')
          loadHistPage(true);
        else
          loadMembers();
      });
      loadBalance(true);
      loadMembers();
    }
  },
  id: 'e0c89e6616',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\r\n  <div class="page fw" data-name="fund-wallet">\r\n\r\n    <!-- NAVBAR -->\r\n    <div class="navbar fw__navbar no-shadow">\r\n      <div class="navbar-bg"></div>\r\n      <div class="navbar-inner">\r\n        <div class="left">\r\n          <a class="link back fw__back">\r\n            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><polyline points="15 18 9 12 15 6"/></svg>\r\n          </a>\r\n        </div>\r\n        <div class="title fw__nav-title">Fund Wallet</div>\r\n        <div class="right">\r\n          <a href="#" class="fw__refresh-btn" id="fw-refresh" title="Refresh">\r\n            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M23 4v6h-6"/><path d="M1 20v-6h6"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></svg>\r\n          </a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <!-- PAGE CONTENT -->\r\n    <div class="page-content fw__content">\r\n\r\n      <!-- \u2550\u2550 BALANCE HERO \u2550\u2550 -->\r\n      <div class="fw__hero">\r\n        <div class="fw__hero-orb fw__hero-orb--1"></div>\r\n        <div class="fw__hero-orb fw__hero-orb--2"></div>\r\n        <div class="fw__hero-inner">\r\n          <div class="fw__hero-top">\r\n            <span class="fw__hero-chip">\r\n              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="5" width="20" height="14" rx="2.5"/><line x1="2" y1="9.5" x2="22" y2="9.5"/></svg>\r\n              Fund Wallet\r\n            </span>\r\n            <span class="fw__hero-live"><span class="fw__hero-dot"></span>Active</span>\r\n          </div>\r\n          <div class="fw__balance-eyebrow">Available Balance</div>\r\n          <div class="fw__balance-val fw-balance">$0.00</div>\r\n\r\n          <div class="fw__stats">\r\n            <div class="fw__stat">\r\n              <span class="fw__stat-ico fw__stat-ico--in">\r\n                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><line x1="12" y1="5" x2="12" y2="19"/><polyline points="19 12 12 19 5 12"/></svg>\r\n              </span>\r\n              <div class="fw__stat-meta">\r\n                <div class="fw__stat-val fw-received">$0.00</div>\r\n                <div class="fw__stat-lbl">Received</div>\r\n              </div>\r\n            </div>\r\n            <div class="fw__stat">\r\n              <span class="fw__stat-ico fw__stat-ico--out">\r\n                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><line x1="12" y1="19" x2="12" y2="5"/><polyline points="5 12 12 5 19 12"/></svg>\r\n              </span>\r\n              <div class="fw__stat-meta">\r\n                <div class="fw__stat-val fw-distributed">$0.00</div>\r\n                <div class="fw__stat-lbl">Distributed</div>\r\n              </div>\r\n            </div>\r\n            <div class="fw__stat">\r\n              <span class="fw__stat-ico fw__stat-ico--inv">\r\n                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>\r\n              </span>\r\n              <div class="fw__stat-meta">\r\n                <div class="fw__stat-val fw-invested">$0.00</div>\r\n                <div class="fw__stat-lbl">Invested</div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <!-- \u2550\u2550 TAB BAR \u2550\u2550 -->\r\n      <div class="fw__tabs">\r\n        <button type="button" class="fw__tab fw__tab--on" data-tab="distribute">\r\n          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>\r\n          Distribute\r\n        </button>\r\n        <button type="button" class="fw__tab" data-tab="history">\r\n          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>\r\n          History\r\n        </button>\r\n      </div>\r\n\r\n      <!-- \u2550\u2550 DISTRIBUTE PANEL \u2550\u2550 -->\r\n      <div class="fw__panel" id="fw-panel-distribute">\r\n\r\n        <!-- Recipient -->\r\n        <div class="fw__field-group">\r\n          <div class="fw__label-row">\r\n            <div class="fw__field-label">Recipient</div>\r\n            <span class="fw__count" id="fw-member-count"></span>\r\n          </div>\r\n          <div class="fw__field-hint">Your network \u2014 up to <b>20 levels</b> deep</div>\r\n          <!-- Selected badge -->\r\n          <div class="fw__recipient-badge" id="fw-recipient-badge" style="display:none">\r\n            <span class="fw__recipient-avatar" id="fw-recipient-avatar">?</span>\r\n            <span class="fw__recipient-text">\r\n              <span class="fw__recipient-name" id="fw-recipient-name"></span>\r\n              <span class="fw__recipient-uname" id="fw-recipient-uname"></span>\r\n            </span>\r\n            <span class="fw__recipient-check">\r\n              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6"><polyline points="20 6 9 17 4 12"/></svg>\r\n            </span>\r\n            <button type="button" class="fw__recipient-clear" id="fw-recipient-clear" aria-label="Clear">\r\n              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>\r\n            </button>\r\n          </div>\r\n          <!-- Search -->\r\n          <div id="fw-search-wrap">\r\n            <div class="fw__search-row">\r\n              <svg class="fw__search-ico" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>\r\n              <input type="text" id="fw-search" class="fw__search-input"\r\n                placeholder="Search name or @username\u2026"\r\n                autocomplete="off" autocapitalize="none" autocorrect="off" spellcheck="false" />\r\n              <button type="button" class="fw__search-clear" id="fw-search-clear" aria-label="Clear search" style="display:none">\r\n                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>\r\n              </button>\r\n            </div>\r\n            <div class="fw__members" id="fw-members">\r\n              <div class="fw__spinner">\r\n                <span class="fw__spin-ring"></span> Loading members\u2026\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <input type="hidden" id="fw-recipient-id" value="">\r\n        </div>\r\n\r\n        <!-- Amount -->\r\n        <div class="fw__field-group">\r\n          <div class="fw__label-row">\r\n            <div class="fw__field-label">Amount to Distribute</div>\r\n            <div class="fw__amount-avail">Bal: <span class="fw-balance-mini">$0.00</span></div>\r\n          </div>\r\n          <div class="fw__amount-wrap">\r\n            <span class="fw__amount-cur">$</span>\r\n            <input type="number" id="fw-dist-amount" class="fw__amount-input"\r\n              placeholder="0.00" min="50" max="50000" step="0.01" inputmode="decimal" />\r\n          </div>\r\n          <div class="fw__chips">\r\n            <button type="button" class="fw__chip" data-fill="min">Min</button>\r\n            <button type="button" class="fw__chip" data-fill="100">$100</button>\r\n            <button type="button" class="fw__chip" data-fill="500">$500</button>\r\n            <button type="button" class="fw__chip" data-fill="max">Max</button>\r\n          </div>\r\n          <div class="fw__amount-hint" id="fw-amount-hint">Loading limits\u2026</div>\r\n        </div>\r\n\r\n        <button type="button" class="fw__submit" id="fw-dist-submit">\r\n          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>\r\n          Distribute Funds\r\n        </button>\r\n        <p class="fw__disclaimer">Funds transfer instantly from your wallet to the recipient\'s fund wallet.</p>\r\n      </div>\r\n\r\n      <!-- \u2550\u2550 HISTORY PANEL \u2550\u2550 -->\r\n      <div class="fw__panel" id="fw-panel-history" style="display:none">\r\n        <div class="fw__hist-list" id="fw-hist-list">\r\n          <div class="fw__spinner"><span class="fw__spin-ring"></span> Loading\u2026</div>\r\n        </div>\r\n        <button type="button" class="fw__more" id="fw-hist-more" style="display:none">\r\n          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><polyline points="6 9 12 15 18 9"/></svg>\r\n          Load More\r\n        </button>\r\n      </div>\r\n\r\n      <div class="fw__end-gap"></div>\r\n    </div>\r\n  </div>\r\n';
      return r;
    }(this);
  },
  style: `
/* ════ FUND WALLET PAGE (fw__*) ════ */
.fw { background: #0A0A0B !important; }
.fw__content {
  background:
    radial-gradient(130% 42% at 50% 0%, rgba(201,169,105,0.12) 0%, transparent 58%),
    #0A0A0B !important;
  padding: 0 !important;
  margin-top: 56px !important;
}
.fw__navbar {
  background: linear-gradient(180deg,#100E09 0%,#0B0A07 100%) !important;
  border-bottom: 1px solid rgba(201,169,105,0.12) !important;
}
.fw__navbar .navbar-bg { background: transparent !important; }
.fw__nav-title { color: #C9A969 !important; font-weight: 700; }
.fw__back  { color: rgba(201,169,105,0.85) !important; }
.fw__refresh-btn {
  width: 34px; height: 34px; display: flex; align-items: center; justify-content: center;
  color: rgba(201,169,105,0.75); border-radius: 50%; background: rgba(201,169,105,0.07);
  margin-right: 14px; transition: background 0.2s ease;
}
.fw__refresh-btn:active { background: rgba(201,169,105,0.20); }

/* ── Hero ── */
.fw__hero {
  margin: 14px 14px 0; position: relative; overflow: hidden;
  border-radius: 22px;
  background: linear-gradient(155deg, #1d180d 0%, #14110a 48%, #181510 100%);
  border: 1px solid rgba(201,169,105,0.24);
  box-shadow: inset 0 1px 0 rgba(201,169,105,0.22), 0 18px 46px -14px rgba(0,0,0,0.8);
}
.fw__hero::before {
  content: ''; position: absolute; top: 0; left: 10%; right: 10%; height: 1px;
  background: linear-gradient(90deg, transparent, rgba(229,201,143,0.85), transparent);
}
.fw__hero-orb { position: absolute; border-radius: 50%; pointer-events: none; }
.fw__hero-orb--1 { width:200px; height:200px; top:-70px; right:-60px; background: radial-gradient(circle, rgba(201,169,105,0.16), transparent 66%); }
.fw__hero-orb--2 { width:130px; height:130px; bottom:-46px; left:-34px; background: radial-gradient(circle, rgba(201,169,105,0.07), transparent 66%); }
.fw__hero-inner { position: relative; z-index: 1; padding: 18px 20px 18px; }
.fw__hero-top { display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px; }
.fw__hero-chip {
  display: inline-flex; align-items: center; gap: 6px;
  font-size: 11px; font-weight: 600; color: #d8b977;
  background: rgba(201,169,105,0.12); border: 1px solid rgba(201,169,105,0.22);
  padding: 5px 10px; border-radius: 20px;
}
.fw__hero-live {
  display: inline-flex; align-items: center; gap: 5px;
  font-size: 10.5px; font-weight: 600; color: rgba(74,222,128,0.85);
}
.fw__hero-dot { width: 6px; height: 6px; border-radius: 50%; background: #4ADE80; box-shadow: 0 0 6px rgba(74,222,128,0.8); }
.fw__balance-eyebrow {
  font-size: 11px; color: rgba(255,255,255,0.42); font-weight: 500;
  letter-spacing: 0.05em; text-transform: uppercase;
}
.fw__balance-val {
  font-size: 40px; font-weight: 800; letter-spacing: -0.03em;
  color: #fff; margin-top: 6px; line-height: 1;
  font-variant-numeric: tabular-nums; font-feature-settings: "tnum" 1;
}
.fw__stats {
  display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 8px;
  margin-top: 20px;
}
.fw__stat {
  display: flex; align-items: center; gap: 8px;
  background: rgba(255,255,255,0.035);
  border: 1px solid rgba(255,255,255,0.06);
  border-radius: 12px; padding: 9px 9px;
}
.fw__stat-ico {
  width: 26px; height: 26px; border-radius: 8px; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center;
}
.fw__stat-ico--in  { background: rgba(74,222,128,0.14); color: #4ADE80; }
.fw__stat-ico--out { background: rgba(248,113,113,0.14); color: #F87171; }
.fw__stat-ico--inv { background: rgba(201,169,105,0.16); color: #C9A969; }
.fw__stat-meta { min-width: 0; }
.fw__stat-val {
  font-size: 12.5px; font-weight: 700; color: rgba(255,255,255,0.90);
  font-variant-numeric: tabular-nums; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.fw__stat-lbl { font-size: 9.5px; color: rgba(255,255,255,0.40); margin-top: 1px; }

/* ── Tabs ── */
.fw__tabs {
  display: flex; margin: 16px 14px 0; gap: 6px;
  background: rgba(255,255,255,0.03);
  border: 1px solid rgba(201,169,105,0.12);
  border-radius: 14px; padding: 4px;
}
.fw__tab {
  flex: 1; display: flex; align-items: center; justify-content: center; gap: 6px;
  padding: 11px; border-radius: 10px; font-size: 13.5px; font-weight: 600;
  color: rgba(255,255,255,0.42); background: none; border: none; cursor: pointer;
  transition: background 0.18s, color 0.18s;
}
.fw__tab--on { background: rgba(201,169,105,0.15); color: #C9A969; box-shadow: inset 0 0 0 1px rgba(201,169,105,0.22); }
.fw__tab svg { opacity: 0.55; }
.fw__tab--on svg { opacity: 1; }

/* ── Panels ── */
.fw__panel { padding: 16px 14px 0; }

/* ── Fields ── */
.fw__field-group { margin-bottom: 18px; }
.fw__label-row { display: flex; align-items: center; justify-content: space-between; margin-bottom: 4px; }
.fw__field-label {
  font-size: 12px; font-weight: 600; color: rgba(201,169,105,0.78);
  letter-spacing: 0.04em; text-transform: uppercase;
}
.fw__field-hint { font-size: 11px; color: rgba(255,255,255,0.34); margin-bottom: 10px; }
.fw__field-hint b { color: rgba(201,169,105,0.72); font-weight: 700; }
.fw__amount-avail { font-size: 11px; color: rgba(255,255,255,0.40); }
.fw__amount-avail .fw-balance-mini { color: #d8b977; font-weight: 700; font-variant-numeric: tabular-nums; }

/* ── Recipient badge ── */
.fw__recipient-badge {
  display: flex; align-items: center; gap: 11px;
  background: rgba(201,169,105,0.08);
  border: 1px solid rgba(201,169,105,0.24);
  border-radius: 13px; padding: 11px 12px;
}
.fw__recipient-avatar {
  width: 38px; height: 38px; border-radius: 50%; flex-shrink: 0;
  background: linear-gradient(135deg,#221c10,#2e2510);
  border: 1px solid rgba(201,169,105,0.32);
  display: flex; align-items: center; justify-content: center;
  font-size: 15px; font-weight: 700; color: #d8b977;
}
.fw__recipient-text { flex: 1; min-width: 0; }
.fw__recipient-name { display: block; font-size: 14px; font-weight: 600; color: rgba(255,255,255,0.90); }
.fw__recipient-uname { display: block; font-size: 11.5px; color: rgba(201,169,105,0.62); margin-top: 1px; }
.fw__recipient-check {
  width: 26px; height: 26px; border-radius: 50%; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center;
  background: rgba(74,222,128,0.16); color: #4ADE80;
}
.fw__recipient-clear {
  width: 28px; height: 28px; border-radius: 50%; background: rgba(255,255,255,0.07);
  border: none; display: flex; align-items: center; justify-content: center;
  color: rgba(255,255,255,0.50); cursor: pointer; flex-shrink: 0;
}
.fw__recipient-clear:active { background: rgba(248,113,113,0.18); color: #F87171; }

/* ── Count badge on labels ── */
.fw__count {
  display: inline-block;
  font-size: 10.5px; font-weight: 700; color: #d8b977;
  background: rgba(201,169,105,0.14); border: 1px solid rgba(201,169,105,0.22);
  border-radius: 10px; padding: 2px 9px; vertical-align: middle;
  letter-spacing: 0; text-transform: none; font-variant-numeric: tabular-nums;
}
.fw__count:empty { display: none; }

/* ── Search clear ── */
.fw__search-clear {
  width: 22px; height: 22px; border-radius: 50%; flex-shrink: 0;
  background: rgba(255,255,255,0.08); border: none; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  color: rgba(255,255,255,0.55);
}
.fw__search-clear:active { background: rgba(255,255,255,0.16); }

/* ── Amount quick-fill chips ── */
.fw__chips { display: flex; gap: 7px; margin-top: 10px; }
.fw__chip {
  flex: 1; padding: 8px 0; border-radius: 9px;
  font-size: 12px; font-weight: 700; cursor: pointer;
  background: rgba(201,169,105,0.08);
  border: 1px solid rgba(201,169,105,0.18);
  color: rgba(201,169,105,0.82);
  transition: background 0.13s, color 0.13s;
}
.fw__chip:active { background: rgba(201,169,105,0.22); color: #f0d49a; }

/* ── Search ── */
.fw__search-row {
  display: flex; align-items: center; gap: 8px;
  background: rgba(255,255,255,0.04);
  border: 1px solid rgba(201,169,105,0.16);
  border-radius: 12px; padding: 0 13px; margin-bottom: 10px;
  transition: border-color 0.16s, box-shadow 0.16s, background 0.16s;
}
.fw__search-row:focus-within {
  border-color: rgba(201,169,105,0.55);
  background: rgba(201,169,105,0.05);
  box-shadow: 0 0 0 3px rgba(201,169,105,0.10);
}
.fw__search-ico { color: rgba(201,169,105,0.50); flex-shrink: 0; transition: color 0.16s; }
.fw__search-row:focus-within .fw__search-ico { color: #C9A969; }
.fw__search-input {
  flex: 1; background: none !important; border: none !important; outline: none !important;
  color: rgba(255,255,255,0.92) !important; font-size: 14px !important;
  padding: 13px 0 !important; caret-color: #C9A969;
}
.fw__search-input::placeholder { color: rgba(255,255,255,0.28); }

/* ── Member list ── */
.fw__members {
  max-height: 216px; overflow-y: auto;
  border: 1px solid rgba(255,255,255,0.07);
  border-radius: 14px; background: rgba(255,255,255,0.025);
  -webkit-overflow-scrolling: touch;
}
.fw__members::-webkit-scrollbar { width: 4px; }
.fw__members::-webkit-scrollbar-thumb { background: rgba(201,169,105,0.25); border-radius: 4px; }
.fw__member-item {
  width: 100%; display: flex; align-items: center; gap: 12px;
  padding: 10px 13px; background: none; border: none; cursor: pointer;
  border-bottom: 1px solid rgba(255,255,255,0.045); text-align: left;
  transition: background 0.13s;
}
.fw__member-item:last-child { border-bottom: none; }
.fw__member-item:hover { background: rgba(201,169,105,0.05); }
.fw__member-item:active { background: rgba(201,169,105,0.10); }
.fw__member-av {
  width: 38px; height: 38px; border-radius: 50%; flex-shrink: 0;
  background: linear-gradient(135deg,#221c10,#2e2510);
  box-shadow: inset 0 0 0 1px rgba(201,169,105,0.28), 0 2px 6px rgba(0,0,0,0.3);
  display: flex; align-items: center; justify-content: center;
  font-size: 15px; font-weight: 700; color: #e0bd7e;
}
.fw__member-info { flex: 1; min-width: 0; }
.fw__member-name { display: block; font-size: 14px; font-weight: 600; color: rgba(255,255,255,0.92); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.fw__member-uname { display: block; font-size: 11.5px; color: rgba(201,169,105,0.62); margin-top: 2px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.fw__member-chev { color: rgba(201,169,105,0.40); flex-shrink: 0; }

/* ── Amount ── */
.fw__amount-wrap {
  display: flex; align-items: center;
  background: rgba(255,255,255,0.04);
  border: 1px solid rgba(201,169,105,0.20);
  border-radius: 12px; padding: 0 14px;
  transition: border-color 0.16s, box-shadow 0.16s, background 0.16s;
}
.fw__amount-wrap:focus-within {
  border-color: rgba(201,169,105,0.55);
  background: rgba(201,169,105,0.05);
  box-shadow: 0 0 0 3px rgba(201,169,105,0.10);
}
.fw__amount-cur { font-size: 20px; font-weight: 700; color: rgba(201,169,105,0.72); flex-shrink: 0; margin-right: 2px; }
.fw__amount-input {
  flex: 1; background: none !important; border: none !important; outline: none !important;
  color: #fff !important; font-size: 20px !important; font-weight: 700 !important;
  padding: 13px 0 !important; caret-color: #C9A969; font-variant-numeric: tabular-nums;
}
.fw__amount-input::placeholder { color: rgba(255,255,255,0.18); }
.fw__amount-hint { margin-top: 7px; font-size: 11.5px; color: rgba(255,255,255,0.35); padding-left: 2px; }

/* ── Submit ── */
.fw__submit {
  width: 100%; margin-top: 18px;
  display: flex; align-items: center; justify-content: center; gap: 8px;
  padding: 15px; border-radius: 14px; font-size: 15px; font-weight: 700;
  background: linear-gradient(135deg,#e5c98f 0%,#C9A969 45%,#a07c38 100%);
  color: #1a1206; border: none; cursor: pointer;
  box-shadow: 0 10px 26px -8px rgba(201,169,105,0.55), inset 0 1px 0 rgba(255,255,255,0.35);
  transition: opacity 0.15s, transform 0.12s;
}
.fw__submit:active { opacity: 0.92; transform: scale(0.98); }
.fw__disclaimer { margin-top: 12px; font-size: 11.5px; color: rgba(255,255,255,0.30); text-align: center; line-height: 1.5; }

/* ── History (fintech transaction cards) ── */
.fw__hist-list { display: flex; flex-direction: column; }

/* Day group header */
.fw__tx-day {
  font-size: 10.5px; font-weight: 700; letter-spacing: 0.06em; text-transform: uppercase;
  color: rgba(201,169,105,0.62); margin: 10px 3px 8px;
}
.fw__tx-day:first-child { margin-top: 2px; }

/* Transaction card */
.fw__tx {
  display: flex; gap: 12px; padding: 12px 13px; margin-bottom: 9px;
  background: linear-gradient(160deg, rgba(255,255,255,0.035), rgba(255,255,255,0.018));
  border: 1px solid rgba(255,255,255,0.06);
  border-radius: 15px;
  transition: border-color 0.14s, background 0.14s;
}
.fw__tx:active { border-color: rgba(201,169,105,0.22); }
.fw__tx-ico {
  width: 40px; height: 40px; border-radius: 12px; flex-shrink: 0; margin-top: 1px;
  display: flex; align-items: center; justify-content: center;
}
.fw__tx-ico--green { background: rgba(74,222,128,0.12); color: #4ADE80; box-shadow: inset 0 0 0 1px rgba(74,222,128,0.18); }
.fw__tx-ico--red   { background: rgba(248,113,113,0.11); color: #F87171; box-shadow: inset 0 0 0 1px rgba(248,113,113,0.18); }
.fw__tx-ico--neutral { background: rgba(255,255,255,0.06); color: rgba(255,255,255,0.55); }

.fw__tx-main { flex: 1; min-width: 0; }
.fw__tx-row { display: flex; align-items: baseline; justify-content: space-between; gap: 10px; }
.fw__tx-title {
  font-size: 14px; font-weight: 650; color: rgba(255,255,255,0.92);
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.fw__tx-amt {
  font-size: 15px; font-weight: 750; flex-shrink: 0; white-space: nowrap;
  font-variant-numeric: tabular-nums;
}
.fw__tx-amt--green { color: #4ADE80; }
.fw__tx-amt--red   { color: #F87171; }
.fw__tx-amt--neutral { color: rgba(255,255,255,0.70); }

.fw__tx-row--sub { margin-top: 3px; }
.fw__tx-time { font-size: 11.5px; color: rgba(255,255,255,0.38); }
.fw__tx-bal {
  font-size: 11px; color: rgba(255,255,255,0.42); flex-shrink: 0;
  font-variant-numeric: tabular-nums;
}

.fw__tx-foot {
  margin-top: 9px; padding-top: 9px;
  border-top: 1px dashed rgba(255,255,255,0.07);
}
.fw__tx-note {
  font-size: 12px; color: rgba(255,255,255,0.55); line-height: 1.45;
}
.fw__tx-ref {
  display: flex; align-items: center; gap: 7px; margin-top: 6px;
}
.fw__tx-ref-tag {
  font-size: 8.5px; font-weight: 800; letter-spacing: 0.07em;
  color: rgba(201,169,105,0.78);
  background: rgba(201,169,105,0.10); border: 1px solid rgba(201,169,105,0.20);
  border-radius: 5px; padding: 2px 6px; flex-shrink: 0;
}
.fw__tx-ref-id {
  font-size: 11px; color: rgba(255,255,255,0.46);
  font-variant-numeric: tabular-nums; letter-spacing: 0.03em; word-break: break-all;
}
.fw__tx-foot:first-child { margin-top: 0; border-top: none; padding-top: 0; }
.fw__tx-foot .fw__tx-ref:first-child { margin-top: 0; }

/* ── Load More ── */
.fw__more {
  width: 100%; margin-top: 14px;
  display: flex; align-items: center; justify-content: center; gap: 7px;
  padding: 12px; border-radius: 12px; font-size: 13.5px; font-weight: 600;
  background: rgba(201,169,105,0.08); border: 1px solid rgba(201,169,105,0.18);
  color: rgba(201,169,105,0.82); cursor: pointer; transition: background 0.15s;
}
.fw__more:active { background: rgba(201,169,105,0.18); }

/* ── Shared ── */
.fw__spinner {
  display: flex; align-items: center; justify-content: center; gap: 9px;
  padding: 26px 0; font-size: 13px; color: rgba(255,255,255,0.40);
}
.fw__spin-ring {
  width: 17px; height: 17px; border-radius: 50%;
  border: 2px solid rgba(201,169,105,0.25); border-top-color: #C9A969;
  animation: fw-spin 0.8s linear infinite; flex-shrink: 0;
}
@keyframes fw-spin { to { transform: rotate(360deg); } }
.fw__empty-msg { padding: 26px 16px; text-align: center; font-size: 13px; color: rgba(255,255,255,0.38); line-height: 1.6; }

/* ── Rich empty / error state ── */
.fw__empty {
  display: flex; flex-direction: column; align-items: center;
  text-align: center; padding: 46px 28px 40px;
}
.fw__empty-ico {
  width: 64px; height: 64px; border-radius: 20px;
  display: flex; align-items: center; justify-content: center;
  margin-bottom: 16px; position: relative;
}
.fw__empty-ico::after {
  content: ''; position: absolute; inset: -6px; border-radius: 24px;
  border: 1px solid rgba(255,255,255,0.04);
}
.fw__empty-ico--gold {
  background: radial-gradient(120% 120% at 50% 0%, rgba(201,169,105,0.16), rgba(201,169,105,0.05));
  box-shadow: inset 0 0 0 1px rgba(201,169,105,0.20);
  color: #C9A969;
}
.fw__empty-ico--err {
  background: radial-gradient(120% 120% at 50% 0%, rgba(248,113,113,0.14), rgba(248,113,113,0.04));
  box-shadow: inset 0 0 0 1px rgba(248,113,113,0.18);
  color: #F87171;
}
.fw__empty-title { font-size: 15px; font-weight: 700; color: rgba(255,255,255,0.82); }
.fw__empty-sub { font-size: 12.5px; color: rgba(255,255,255,0.40); margin-top: 7px; line-height: 1.55; max-width: 250px; }

.fw__end-gap { height: 56px; }
`,
  styleScoped: false
};